module.exports = __webpack_public_path__ + "static/patent_adam_staff-97c3a686e7fe81cf01c2b4c65a575140.png";